import breakpointsRaw from './breakpointsRaw';

const queries = Object.freeze({
  mobile: `(max-width: ${breakpointsRaw.sm}px)`,
  minTablet: `(min-width: ${breakpointsRaw.sm + 0.02}px)`,
  tablet: `(min-width: ${breakpointsRaw.sm}px) and (max-width: ${breakpointsRaw.lg - 0.02}px)`,
  maxTablet: `(max-width: ${breakpointsRaw.lg - 0.02}px)`,
  minDesktop: `(min-width: ${breakpointsRaw.lg}px)`,
  maxDesktop: `(max-width: ${breakpointsRaw.xl - 0.02}px)`,
  minLargeDesktop: `(min-width: ${breakpointsRaw.xl - 0.02}px)`
});

export default queries;
